import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Clock, LogIn } from 'lucide-react';

const SessionTimeoutModal = ({ isOpen, onLogin }) => {
  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent 
        className="sm:max-w-md"
        data-testid="session-timeout-modal"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100">
            <Clock className="h-7 w-7 text-amber-600" />
          </div>
          <DialogTitle className="text-center text-xl">
            Session Expired
          </DialogTitle>
          <DialogDescription className="text-center pt-2">
            Your session has timed out for security reasons. Please log in again to continue working.
          </DialogDescription>
        </DialogHeader>
        
        <div className="bg-slate-50 rounded-lg p-4 mt-2">
          <p className="text-sm text-slate-600 text-center">
            Don't worry — any unsaved changes in forms may still be in your browser. 
            After logging in, you can continue where you left off.
          </p>
        </div>

        <DialogFooter className="mt-4 sm:justify-center">
          <Button 
            onClick={onLogin}
            className="w-full sm:w-auto gap-2"
            data-testid="session-timeout-login-btn"
          >
            <LogIn className="h-4 w-4" />
            Log In Again
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SessionTimeoutModal;
